import * as React from 'react';
import { toast } from 'react-toastify';

import { CopyOutlined, LinkOutlined } from '@ant-design/icons';
import { Modal, Button, Typography } from 'antd';

import { CHECKOUT_ELEMENTS_URL } from 'settings';
import { Space } from 'v2/components/Shared/Space';
import type { ProductOffer } from 'v2/interfaces/product';

import { PricesList } from './PricesList';

type LinksModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  offer: ProductOffer;
};

function LinksModal({ isOpen, closeModal, offer }: LinksModalProps) {
  function mountOfferLink(offer: ProductOffer) {
    return `${CHECKOUT_ELEMENTS_URL}/${offer.key}`;
  }

  function copyLinkToClipboard(link: string) {
    navigator.clipboard.writeText(link);
    toast.success('Link copiado para a área de transferência');
  }

  return (
    <Modal open={isOpen} onCancel={closeModal} width={700} title='Links da oferta' footer={null}>
      <div className='pb-[60px]'>
        <Typography.Text strong className='mt-4 mb-3 block text-lg! leading-6' id='links-modal-offer-name'>
          {offer.name}
        </Typography.Text>
        <p className='mb-1 text-[14px] leading-[22px]'>Página de pagamento (Checkout Sun)</p>
        <div className='border-border flex items-center gap-2 border py-1 pr-2 pl-[13px]'>
          <LinkOutlined style={{ fontSize: 18 }} />
          <a
            className='overflow-hidden text-[14px] leading-6 text-ellipsis whitespace-nowrap text-black hover:underline'
            id='links-modal-offer-link'
            href={mountOfferLink(offer)}
            target='_blank'
            rel='noreferrer'
          >
            {mountOfferLink(offer)}
          </a>
          <Button
            type='text'
            id='links-modal-copy-button'
            className='ml-auto'
            size='small'
            icon={<CopyOutlined style={{ fontSize: 18 }} />}
            onClick={() => copyLinkToClipboard(mountOfferLink(offer))}
          />
        </div>
        {offer.prices?.length > 0 && <Space axis='vertical' size={30} />}
        <PricesList offer={offer} />
      </div>
    </Modal>
  );
}

export { LinksModal };
